/**
 * 48 コマ表の参照列 (当日実績・過去実績・確定履歴) の列見出しにマウスを乗せている間、
 * チャートの対応する系列を強調し、ほかの系列を減光する規則 (AC-DFD-006a-6)。
 *
 * - 強調: 太線 (最低 3.75px)・実線・データ点。 色に頼らずに目立たせる
 * - 減光: 不透明度 0.07
 * - 需要想定値 (編集対象) は比べる相手なので呼び出し側で対象から外し、常に見える状態に保つ
 * - 凡例で非表示にした系列は Recharts の `hide` のまま (ここでは表示/非表示を扱わない)
 *
 * 度合いは spec のとおりデザイナー裁量で、値は design `demand/forecast-today.html` の
 * `_seriesOp` / `_emphW` / `_emphDot` に揃える。
 */

/** 減光した系列の不透明度。 */
export const DIMMED_SERIES_OPACITY = 0.07

/** 強調した系列の最低の線幅 (px)。 */
const EMPHASIZED_MIN_STROKE_WIDTH = 3.75

export type SeriesEmphasis = {
  /** 線・面に掛ける不透明度 (強調なし・強調中の系列は 1)。 */
  opacity: number
  /** この系列が強調中か (太線・実線・データ点にする)。 */
  isEmphasized: boolean
}

/**
 * @param emphasizedKey 強調中の系列のグループ key (列見出しのホバー中だけ。 外れたら undefined)
 * @param seriesKey 判定する系列のグループ key。 過去日の気温・露点は同じ日の需要と同じ key
 *   (`past_{idx}`) で渡すと、その日の線がまとめて残る
 */
export function seriesEmphasis(
  emphasizedKey: string | undefined,
  seriesKey: string,
): SeriesEmphasis {
  if (emphasizedKey === undefined) return { opacity: 1, isEmphasized: false }
  const isEmphasized = seriesKey === emphasizedKey
  return {
    opacity: isEmphasized ? 1 : DIMMED_SERIES_OPACITY,
    isEmphasized,
  }
}

/** 強調した系列の線幅 (元の線幅 + 2、ただし最低 3.75px)。 */
export function emphasizedStrokeWidth(baseWidth: number): number {
  return Math.max(EMPHASIZED_MIN_STROKE_WIDTH, baseWidth + 2)
}
